/* unplugin-vue-components disabled */import script from "./mobile.vue?vue&type=script&setup=true&lang=js"
export * from "./mobile.vue?vue&type=script&setup=true&lang=js"

import "./mobile.vue?vue&type=style&index=0&id=1d854fed&lang=scss&scoped=true"
import "./mobile.vue?vue&type=style&index=1&id=1d854fed&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d854fed"]])

export default __exports__